








































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { BModal } from 'bootstrap-vue';
import { Sheet, SheetField, Examinee, SheetActivityItem } from "../../modules/teacher/SortAnswerImage"

export interface Data {
  sheet_id: string
  sheet: Sheet
  sheetField: SheetField
  examinees: Examinee[]
  sheetActivityItems: SheetActivityItem[]
  colCount: number
  windowHeight: number
  fieldMargin: number
  fieldPadding: number
  fieldAreaWidth: number
  fieldAreaHeight: number
  fieldImageWidth: number
  fieldImageHeight: number
  scale: number
  selectedIdx: number
  changeTargetIdx: number
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    const modalRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_id: null,
      sheet: null,
      sheetField: null,
      examinees: new Array<Examinee>(),
      sheetActivityItems: new Array<SheetActivityItem>(),
      colCount: 0,
      windowHeight: 0,
      fieldMargin: 5,
      fieldPadding: 8,
      fieldAreaWidth: 0,
      fieldAreaHeight: 0,
      fieldImageWidth: 0,
      fieldImageHeight: 0,
      scale: 0,
      selectedIdx: 0,
      changeTargetIdx: 0,
      errors: new Array<string>(),
    });

    /******************************
     * 拡大・縮小ボタン押下
     ******************************/

    const changeColCount = (addValue: number) => {
      blur();
      if(state.colCount + addValue <= 0){
        return;
      }

      state.colCount += addValue;
      adjustLayout();
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {
      const windowHeight = window.innerHeight;
      const headerArea = document.getElementById("header-area");
      const imageArea = document.getElementById("image-area");
      state.windowHeight = windowHeight;

      // 画像表示エリアの高さを画面サイズに合わせる
      if(headerArea != null && imageArea != null){
        imageArea.style.height = (windowHeight - imageArea.offsetTop) + "px";
      }

      // 切出し枠1個あたりのサイズ、切出し枠内のimgタグのサイズを取得
      state.fieldAreaWidth = imageArea.clientWidth / state.colCount - (state.fieldMargin * 2);
      state.fieldImageWidth = state.fieldAreaWidth - (state.fieldPadding * 2);
      state.scale = state.fieldImageWidth / (state.sheetField.width);
      state.fieldImageHeight = Math.round((state.sheetField.height) * state.scale);
      state.fieldAreaHeight = state.fieldImageHeight + state.fieldPadding * 2;
    }

    /************************************************************
     * 切り出し画像の親DivのCSS
     ************************************************************/

    const fieldAreaStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${state.fieldAreaWidth}px`;
      style["height"] = `${state.fieldAreaHeight}px` + 20;
      style["padding"] = `${state.fieldPadding}px`;
      style["margin-left"] = `${state.fieldMargin}px`;
      style["margin-right"] = `${state.fieldMargin}px`;

      style["background-color"] = "#c0c0e2";
      return style;
    });

    /************************************************************
     * 切り出し画像imgタグのCSS
     ************************************************************/

    const fieldImageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${state.fieldImageWidth}px`;
      style["height"] = `${state.fieldImageHeight}px`;
      return style;
    });

    /************************************************************
     * 選択中の生徒情報
     ************************************************************/

    const selectedExaminee = computed((): any => {
      return state.examinees[state.selectedIdx];
    });

    /************************************************************
     * 選択中の生徒の切出し画像
     ************************************************************/

    const selectedBase64Image = computed((): any => {
      return state.sheetActivityItems[state.selectedIdx].base64_image;
    });

    /************************************************************
     * 変更対象用のプルダウン
     ************************************************************/

    const comboboxExaminees = computed((): any => {
      const rtn: any[] = [];
      if(context.root.$store.getters.isEntranceOrPractice){
        for(let i = 0; i < state.examinees.length; i++){
          const student_no_character = state.examinees[i].student_no_character ? state.examinees[i].student_no_character : "";
          const student_name = state.examinees[i].student_name ? state.examinees[i].student_name : "";
          rtn.push({value: i, text: `${student_no_character} ${student_name}`});
        }
      }else{
        for(let i = 0; i < state.examinees.length; i++){
          const student_no = state.examinees[i].student_no ? state.examinees[i].student_no : "";
          const student_no_character = state.examinees[i].student_no_character ? state.examinees[i].student_no_character : "";
          const student_name = state.examinees[i].student_name ? state.examinees[i].student_name : "";
          rtn.push({value: i, text: `${student_no}番 ${student_no_character} ${student_name}`});
        }
      }
      return rtn;
    });

    /************************************************************
     * 答案入れ替え用モーダル表示
     ************************************************************/

    const openModal = (selectedIdx: number) => {
      state.selectedIdx = selectedIdx;
      modalRef.value.show();
    }

    /************************************************************
     * 生徒変更実行
     ************************************************************/

    const changeExaminee = () => {

      if(state.selectedIdx == state.changeTargetIdx){
        alert("選択中の生徒と変更先の生徒が同じです。");
        return;
      }

      // 配列内の対象要素を入れ替え
      [state.sheetActivityItems[state.selectedIdx], state.sheetActivityItems[state.changeTargetIdx]] = [state.sheetActivityItems[state.changeTargetIdx], state.sheetActivityItems[state.selectedIdx]];
      state.sheetActivityItems = state.sheetActivityItems.map(x => x);

      const sheetActivityItems = new Array<SheetActivityItem>();
      for(let i = 0; i < state.examinees.length; i++){
        // 入れ替えにより出欠状態が変わる場合があるので、答案アップ状態から出欠状態を更新
        state.examinees[i].absent_flg = state.sheetActivityItems[i].base64_image == null;
        state.sheetActivityItems[i].student_id = state.examinees[i].student_no;
        sheetActivityItems.push(state.sheetActivityItems[i]);
      }

      // 配列入れ替えだけでは画面の切出し画像が更新されないため、新しく生成した配列を代入
      state.sheetActivityItems = sheetActivityItems;
      modalRef.value.hide();
    }

    /************************************************************
     * 更新API
     ************************************************************/

    const upadte = async () => {
      
      if (!window.confirm('受験者情報を変更内容を登録します。よろしいですか？')) {
        return;
      }
      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sort_answer_image/update/${state.sheet_id}`, {examinees: state.examinees, sheet_activity_items: state.sheetActivityItems}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/teacher/sort_answer_image?sheet_id=${state.sheet_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.sheetField = new SheetField(response.data.sheet_field);
        state.examinees = response.data.examinees.map((x: any) => new Examinee(x));
        state.sheetActivityItems = response.data.sheet_activity_items.map((x: any) => new SheetActivityItem(x));
        state.colCount = state.sheetField.width > state.sheetField.height ? 5 : 12;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`画面の表示に失敗しました。\n${error.response.data.errors[0]}`);
        }else{
          alert(`画面の表示に失敗しました。`);
        }
        window.history.back();
      });
      
      window.addEventListener("resize", adjustLayout);
      adjustLayout();

      context.root.$store.dispatch("hideOverlay");
    });

    /************************************************************
     * before unmount windowイベント解除
     ************************************************************/
    
    onBeforeUnmount(async () => {      
      window.removeEventListener("resize", adjustLayout);
    });

    return {
      ...toRefs(state),
      modalRef,
      changeColCount,
      fieldAreaStyle,
      fieldImageStyle,
      openModal,
      selectedExaminee,
      selectedBase64Image,
      comboboxExaminees,
      changeExaminee,
      upadte,
    }
  }
});

